export default __webpack_public_path__ + "static/media/withBongo.98118bd0.jpeg";